import { render, staticRenderFns } from "./UploadAsset.vue?vue&type=template&id=977fe29e"
import script from "./UploadAsset.vue?vue&type=script&lang=js"
export * from "./UploadAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports